import { NavLink, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useUI } from "@/context/UIContext";
import { useNewAlertsCount } from "@/hooks/useNewAlertsCount";
import { MOBILE_NAV, NAV_ITEMS } from "./navConfig";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { MoreHorizontal, Radar, X } from "lucide-react";

export function MobileBottomNav() {
  const { setMobileNavOpen } = useUI();
  const newAlertsCount = useNewAlertsCount();
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-around border-t border-border/60 bg-background/90 px-2 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl lg:hidden"
    >
      {MOBILE_NAV.map((item) => {
        const Icon = item.icon;
        const badge = item.to === "/alerts" ? newAlertsCount : item.badge;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            className={({ isActive }) =>
              cn(
                "relative flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors",
                isActive ? "text-primary" : "text-muted-foreground"
              )
            }
          >
            <span className="relative">
              <Icon className="h-6 w-6" />
              {badge > 0 && <span className="absolute -right-1.5 -top-1 h-2 w-2 rounded-full bg-primary" />}
            </span>
            {item.label}
          </NavLink>
        );
      })}
      <button
        onClick={() => setMobileNavOpen(true)}
        className="flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium text-muted-foreground"
        data-testid="mobile-nav-more"
      >
        <MoreHorizontal className="h-6 w-6" />
        More
      </button>
    </nav>
  );
}

export function MobileNavDrawer() {
  const { mobileNavOpen, setMobileNavOpen } = useUI();
  const navigate = useNavigate();
  const newAlertsCount = useNewAlertsCount();
  return (
    <Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
      <SheetContent side="left" className="w-[280px] border-border/60 bg-surface p-0">
        <div className="flex h-16 items-center justify-between border-b border-border/60 px-4">
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary">
              <Radar className="h-5 w-5 text-primary-foreground" />
            </div>
            <div className="font-display text-[15px] font-semibold">ARC Beacon</div>
          </div>
          <button onClick={() => setMobileNavOpen(false)} className="text-muted-foreground"><X className="h-5 w-5" /></button>
        </div>
        <div className="space-y-1 overflow-y-auto p-3">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const badge = item.to === "/alerts" ? newAlertsCount : item.badge;
            return (
              <button
                key={item.to}
                onClick={() => { navigate(item.to); setMobileNavOpen(false); }}
                className="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium text-muted-foreground transition hover:bg-secondary/60 hover:text-foreground"
              >
                <Icon className="h-5 w-5" /> {item.label}
                {badge > 0 && <span className="ml-auto rounded-full bg-primary/15 px-1.5 py-0.5 text-[10px] font-semibold text-primary">{badge}</span>}
              </button>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
